import { render, staticRenderFns } from "./RiskTag.vue?vue&type=template&id=5149cca4&"
import script from "./RiskTag.vue?vue&type=script&lang=js&"
export * from "./RiskTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports